import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseViewComponent, StarRatingViewKind } from '@sb/library/base';

@Component({
    selector: 'lib-star-rating',
    templateUrl: './star-rating.component.html',
    styleUrls: ['./star-rating.component.scss'],
})
export class StarRatingComponent extends BaseViewComponent {    
    private _starRating!: number;

    @Input() loading: boolean = false;
    @Input() starCount: number = 5; // number of stars its out of
    @Input() numReviews?: number;
    @Input() kind: StarRatingViewKind = StarRatingViewKind.Summary;
    @Input() disabled: boolean = false;
    @Input() websiteTextClass: string = "";

    @Input()  // out of 100
    set ratingValue(value: number) {
        if (value) {
            this._starRating = this.CalculateStars(value);
        }
    }

    @Output() summaryClicked: EventEmitter<void> = new EventEmitter();

    private _starLevels: number[] = [];

    override ngOnInit(): void {
        super.ngOnInit();
        this._starLevels = Array.from({ length: this.starCount }, (_, i) => i + 1);
    }

    SummaryClicked(): void {
        this.summaryClicked.emit();
    }

    private CalculateStars(ratingValue: number | null): number {
        if (ratingValue) {
            return (ratingValue / 100) * this.starCount;
        }
        return 0;
    }

    get starLevels(): number[] {
        return this._starLevels;
    }

    get starRating(): number | null {
        return this._starRating;
    }
}
